import { Component, Input, OnInit } from '@angular/core';
import { HeaderType } from 'src/app/domain/interfaces/header/header-type-enum';
import { IMenuOption } from 'src/app/domain/interfaces/menu/menu-option';
import { IUser } from 'src/app/domain/interfaces/user/interface-user';
import { IHeaderStyles } from 'src/app/domain/interfaces/views/interface-header-styles';
import { FeatureProduct } from 'src/app/domain/models/funnel/feature-product';
import { FunnelFlow } from 'src/app/domain/models/funnel/register-funnels/funnel-flow-register';
import { FunnelService } from 'src/app/infraestructure/drive-adapter/funnel-service/funnel.service';
import { MenuService } from 'src/app/infraestructure/drive-adapter/menu-service/menu.service';
import { AuthService } from 'src/app/infraestructure/drive-adapter/user-service/auth.service';
import { HideForBrandsService } from 'src/app/infraestructure/services-views/hide-for-brands-service/hide-for-brands.service';

@Component({
  selector: 'app-header-funnels-and-member-portal',
  templateUrl: './header-funnels-and-member-portal.component.html',
  styleUrls: ['./header-funnels-and-member-portal.component.scss']
})
export class HeaderFunnelsAndMemberPortalComponent implements OnInit {
  @Input() ShowMenuMobile = true;
  @Input() RedirectWithLogo = true;  
  @Input() headerType = HeaderType.Basic;
  public HeaderType = HeaderType;
  @Input() headerStyles!: IHeaderStyles;
  @Input() showClassVerify?:boolean = false;
  public ShowMenu = false;
  public UserLogin!: IUser;
  public menuItems: Array<IMenuOption> = [];
  @Input() FunnelFlow: FunnelFlow = { UserTemporary: { addresses: [] } };

  constructor(private authService: AuthService, private menuService: MenuService, private hideForBrand: HideForBrandsService) { }

  ngOnInit(): void {
    let UserLoginSubscriber = this.authService.GetUserLogin().subscribe((UserLogin: IUser) => {
      this.UserLogin = UserLogin;
      if (this.UserLogin?.id) {
        this.menuItems = this.menuService.getMenu();
        this.menuItems.forEach(option => {
          this.validateMenuOptionsByProduct(option);
        });
        this.validateServicesActivation();
        this.ShowMenu = true;
      }
    });

    UserLoginSubscriber.unsubscribe();

  }

  validateMenuOptionsByProduct(option: IMenuOption) {
    if (this.hideForBrand?.getHideForBrands(option?.HideForBrands ?? [""])) {
      this.menuItems.splice(option?.SubOptions!.indexOf(option), 1, undefined!);
    }
    else if (!this.productIsActive(option?.FeatureProduct!) && option?.HideIfFeatureProductIsDisabled) {
      this.menuItems.splice(this.menuItems.indexOf(option), 1, undefined!);
    } else {
      option?.SubOptions?.forEach(subOption => {
        if (!this.productIsActive(subOption?.FeatureProduct!) && subOption?.HideIfFeatureProductIsDisabled) {
          option?.SubOptions!.splice(option?.SubOptions!.indexOf(subOption), 1, undefined!);
        } else if (this.hideForBrand.getHideForBrands(subOption?.HideForBrands ?? [""])) {
          option?.SubOptions?.splice(option?.SubOptions!.indexOf(subOption), 1, undefined!);
        }
      });
    }
  }
  
  productIsActive(featureProducts: FeatureProduct[]): boolean {
    if (!featureProducts || featureProducts.length == 0) {
      return false;
    }
    return featureProducts.some(featureProduct => {
      const userProduct = this.UserLogin?.userProducts?.find(
        product => product.konnektiveCampaignProduct?.featureProduct == featureProduct
      );
      return userProduct?.isActive ?? false; 
    });
  }  

  validateServicesActivation() {
    if(!this.UserLogin?.activePayroll) {
      let option = this.menuItems.find(option => option?.Title?.includes("Income"))!;
      this.menuItems.splice(this.menuItems.indexOf(option), 1);
    }
    if(!this.UserLogin?.activeReward) {
      let option = this.menuItems.find(option => option?.Title?.includes("Rewards"))!;
      this.menuItems.splice(this.menuItems.indexOf(option), 1);
    }
  }

  Logout() {
    this.ShowMenu = false;
    this.authService.Logout();
  }

  QuickTour() {
    this.authService.ShowToolTips();
  }



}
